import { getCookie, setCookie, ONE_YEAR } from '@zuldigital/cookie';
import { getDeviceName } from './device';
import { generateUUIDV4 } from './uuid';
export var X_DEVICE_NAME = 'X-Device-Name';
export var X_UDID = 'X-UDID';
var FIVE_YEARS = ONE_YEAR * 5;

var getOrSetUDID = () => {
  var UDID = getCookie(X_UDID) || generateUUIDV4();
  setCookie({
    name: X_UDID,
    value: UDID,
    expiresAt: FIVE_YEARS
  });
  return UDID;
};

export var getIdentifierHeaders = () => {
  return {
    [X_DEVICE_NAME]: getDeviceName(),
    [X_UDID]: getOrSetUDID()
  };
};
//# sourceMappingURL=identifierHeaders.js.map